import { Button, Paper, Typography } from '@mui/material';
import Grid from '@mui/material/Grid2';
import { useState } from 'react';
import Accordion from 'src/components/accordion/accordion';
import { Iconify } from 'src/components/iconify';
import { themeConfig } from 'src/theme';

const BUS_AKAP_TERM_CONDITIONS = [
  {
    header: 'Pemesanan Tiket',
    items: [
      'Pemesanan tiket dapat dilakukan melalui website, kontak agen resmi Puspa Jaya, atau datang langsung ke lokasi agen perwakilan.',
      'Anak dengan tinggi badan di atas 90 cm akan dikenakan tiket dengan biaya penuh.',
      'Pembatalan keberangkatan dapat dilakukan maksimal H-1 tanggal keberangkatan dan akan dikenakan biaya pembatalan sebesar 30% dari harga tiket dan uang akan dikembalikan sebesar 70% dari harga tiket.',
      'Pada saat hari keberangkatan, tiket yang sudah dipesan tidak dapat dibatalkan (hangus).',
      'Penumpang dapat melakukan perubahan jadwal (Reschedule) maksimal H-1 tanggal keberangkatan dan perubahan jadwal hanya dapat dilakukan 1 (satu) kali.',
      'Tiket penumpang yang sudah pernah dilakukan perubahan jadwal, tidak dapat dilakukan Refund/Pembatalan (Batal Lunas).',
      'Tiket resmi Puspa Jaya sudah termasuk Asuransi Jasa Raharja.',
    ],
  },
  {
    header: 'Ketentuan Bagasi dan Barang Bawaan',
    items: [
      'Penumpang hanya diperbolehkan membawa bagasi dengan maksimal berat 25 kg/tiket. Bagasi dengan berat diatas 25 kg akan dikenakan biaya tambahan.',
      'Seluruh barang yang dibawa ke dalam ruang kabin penumpang sepenuhnya menjadi tanggung jawab penumpang.',
      'Penumpang tidak diperbolehkan membawa barang-barang ilegal, bahan yang mudah terbakar, barang-barang dengan bau menyengat, dan segala jenis binatang.',
    ],
  },
  {
    header: 'Check-In dan Hari Keberangkatan',
    items: [
      'Check-in sudah dapat dilakukan 1 jam sebelum jam keberangkatan dengan menunjukan kode booking atau tiket fisik.',
      'Sesudah check-in, petugas akan memberikan plat nomor bus dan nomor lambung bus.',
      'Ketika menaiki bus, pastikan plat nomor bus, nomor lambung bus, dan nomor kursi sudah sesuai dengan tiket pesanan.',
      'Petugas akan melakukan final cek di dalam kabin untuk memastikan penumpang sudah berada pada tempat duduk di dalam armada yang benar sesuai nomor kursi, nomor plat, serta nomor lambung bus.',
    ],
  },
];

const BUS_PARIWISATA_TERM_CONDITIONS = [
  {
    header: 'Ketentuan Harga',
    items: [
      'Penyewa di luar kota dikenakan biaya penjemputan sesuai dengan jarak.',
      'Rute perjalanan sesuai dengan jadwal yang telah disepakati.',
      'Uang muka (Down Payment) sebesar 25% dari harga sewa keseluruhan.',
      'Pelunasan pembayaran sewa bus dilakukan sebelum hari keberangkatan.',
      'Harga tidak termasuk pajak yang berlaku.',
      'Penambahan biaya kapal cepat (Executive) sebesar Rp900.000 untuk big bus dan Rp700.000 untuk medium bus (Pulang Pergi).',
    ],
  },
  {
    header: 'Biaya yang Ditanggung Perusahaan',
    items: [
      'Bahan Bakar Minyak (BBM)',
      'Biaya Jalan Tol',
      'Penyeberangan Dengan Kapal Reguler',
      'Uang Makan Kru Bus',
    ],
  },
  {
    header: 'Biaya yang Ditanggung Penyewa',
    items: ['Biaya Masuk Tempat Wisata', 'Parkir Bus', 'Penginapan Kru Bus'],
  },
];

export const TermCondition = () => {
  const terms = [BUS_AKAP_TERM_CONDITIONS, BUS_PARIWISATA_TERM_CONDITIONS];
  const [termIndex, setTermIndex] = useState(0);

  return (
    <Grid sx={{ marginTop: '100px' }}>
      <Typography variant="h3" component="h2" textAlign="center">
        Aturan dan Ketentuan
      </Typography>
      <Paper
        elevation={8}
        sx={{
          padding: {
            xs: '20px',
            md: '50px',
          },
          marginTop: {
            xs: '16px',
            md: '28px',
          },
          borderRadius: '20px',
        }}
      >
        <Grid
          container
          gap={2}
          sx={{
            justifyContent: 'center',
            marginBottom: '38px',
          }}
        >
          <Button
            variant={termIndex == 0 ? 'contained' : 'outlined'}
            color="primary"
            sx={{
              background: termIndex == 0 ? themeConfig.gradient.primary.bold : 'inherit',
              borderRadius: '50px',
            }}
            size="large"
            onClick={() => setTermIndex(0)}
            startIcon={<Iconify icon="mdi:bus" />}
          >
            Bus AKAP
          </Button>
          <Button
            variant={termIndex == 1 ? 'contained' : 'outlined'}
            color="primary"
            sx={{
              background: termIndex == 1 ? themeConfig.gradient.primary.bold : 'inherit',
              borderRadius: '50px',
            }}
            size="large"
            onClick={() => setTermIndex(1)}
            startIcon={<Iconify icon="solar:bus-bold" />}
          >
            Bus Pariwisata
          </Button>
        </Grid>
        <Accordion>
          {terms[termIndex].map((e, i) => (
            <Accordion.Item key={i} defaultOpen={i === 0}>
              <Accordion.Header>
                <Typography variant="h4" component="h3" textAlign="left">
                  {e.header}
                </Typography>
              </Accordion.Header>
              <Accordion.Body>
                <ol className="list-decimal list-outside px-[32px]">
                  {e.items.map((item, ii) => (
                    <li key={ii} className="leading-4 text-justify">
                      {item}
                    </li>
                  ))}
                </ol>
              </Accordion.Body>
            </Accordion.Item>
          ))}
        </Accordion>
      </Paper>
    </Grid>
  );
};
